import React from "react";

const Icon_4 = () => {
  return (
    <>
      <svg
         width="216"
        height="156"
        viewBox="0 0 191 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3225_23802)">
          <path
            d="M4.71484 90.4897C4.71516 66.4549 14.254 43.4046 31.2331 26.4095C48.2122 9.41432 71.2407 -0.133594 95.2527 -0.133911C119.265 -0.133911 142.294 9.41417 159.273 26.4089C176.252 43.4044 185.79 66.4548 185.791 90.4897H4.71484Z"
            fill="url(#paint0_linear_3225_23802)"
          />
          <path
            d="M139.766 90.7888C139.766 67.0072 120.505 47.7285 96.7461 47.7285C72.9871 47.7285 53.7266 67.0072 53.7266 90.7888C53.7266 114.57 72.9871 133.849 96.7461 133.849C120.505 133.849 139.766 114.57 139.766 90.7888Z"
            fill="#09141F"
          />
          <g opacity="0.2">
            <path
              d="M137.409 90.7885C137.409 68.3101 119.203 50.0878 96.7462 50.0878C74.2891 50.0878 56.084 68.3101 56.084 90.7885C56.084 113.267 74.2891 131.489 96.7462 131.489C119.203 131.489 137.409 113.267 137.409 90.7885Z"
              fill="#182631"
            />
            <path
              d="M137.409 90.7885C137.409 68.3101 119.203 50.0878 96.7462 50.0878C74.2891 50.0878 56.084 68.3101 56.084 90.7885C56.084 113.267 74.2891 131.489 96.7462 131.489C119.203 131.489 137.409 113.267 137.409 90.7885Z"
              fill="#182631"
              stroke="#467B85"
              strokeWidth="4.57281"
            />
            <path
              d="M137.409 90.7885C137.409 68.3101 119.203 50.0878 96.7462 50.0878C74.2891 50.0878 56.084 68.3101 56.084 90.7885C56.084 113.267 74.2891 131.489 96.7462 131.489C119.203 131.489 137.409 113.267 137.409 90.7885Z"
              fill="#182631"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="4.57281"
            />
          </g>
          <path
            opacity="0.5"
            d="M96.7476 136.799C122.134 136.799 142.714 116.199 142.714 90.7887C142.714 65.3781 122.134 44.7788 96.7476 44.7788C71.3611 44.7788 50.7812 65.3781 50.7812 90.7887C50.7812 116.199 71.3611 136.799 96.7476 136.799Z"
            fill="url(#paint1_radial_3225_23802)"
          />
          <path
            opacity="0.4"
            d="M135.051 90.7888C135.051 69.6135 117.902 52.4475 96.7464 52.4475C75.5911 52.4475 58.4414 69.6135 58.4414 90.7888C58.4414 111.964 75.5911 129.13 96.7464 129.13C117.902 129.13 135.051 111.964 135.051 90.7888Z"
            stroke="url(#paint2_linear_3225_23802)"
            strokeWidth="1.52401"
          />
          <g filter="url(#filter0_d_3225_23802)">
            <path
              d="M91.5045 92.5905H82.2398C80.9268 92.5905 80.1989 91.0591 81.0224 90.0297L99.4999 66.9258C100.425 65.7689 102.281 66.4275 102.281 67.9128V86.2468C102.281 86.5944 102.56 86.8761 102.906 86.8761H111.252C112.526 86.8761 113.265 88.3285 112.521 89.3693L94.9623 113.94C94.0754 115.181 92.1302 114.549 92.1302 113.021V93.2198C92.1305 93.0533 92.0648 92.8935 91.9475 92.7755C91.8302 92.6575 91.6708 92.591 91.5045 92.5905Z"
              fill="#6FB3AB"
            />
          </g>
          <path
            d="M139.766 90.7888C139.766 67.0072 120.505 47.7285 96.7461 47.7285C72.9871 47.7285 53.7266 67.0072 53.7266 90.7888C53.7266 114.57 72.9871 133.849 96.7461 133.849C120.505 133.849 139.766 114.57 139.766 90.7888Z"
            stroke="url(#paint3_linear_3225_23802)"
            strokeWidth="1.52401"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3225_23802"
            x="56.7564"
            y="49.2517"
            width="79.9793"
            height="96.0967"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="6.83332" />
            <feGaussianBlur stdDeviation="11.9587" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3225_23802"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3225_23802"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_3225_23802"
            x1="100.5"
            y1="2.5"
            x2="99.8471"
            y2="108.344"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0112442" stopColor="#17242F" />
            <stop offset="1" stopColor="#040D18" stopOpacity="0" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_3225_23802"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(96.7476 90.7887) rotate(90) scale(42.4705 42.4303)"
          >
            <stop offset="0.161" stopColor="#324858" />
            <stop offset="1" stopColor="#040D15" stopOpacity="0" />
          </radialGradient>
          <linearGradient
            id="paint2_linear_3225_23802"
            x1="56.6737"
            y1="64.4355"
            x2="131.367"
            y2="128.521"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0F1B26" />
            <stop offset="1" stopColor="#09131E" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3225_23802"
            x1="96.7461"
            y1="48.3183"
            x2="96.7461"
            y2="133.259"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.29152" stopColor="#344551" />
            <stop offset="0.748385" stopColor="#050E19" />
          </linearGradient>
          <clipPath id="clip0_3225_23802">
            <rect width="191" height="137" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default Icon_4;
